import { ROOT_ROUTES } from '../../../app-routing.module';
import { CLINICAL_ROUTES } from '@clinical/clinical-routes.module';
import { DERIVATIONS_ROUTES } from '@clinical/derivations/derivations-routes.module';
import { PAPERWORK_DERIVATIONS_DEFINITION } from '@clinical/derivations/constants/paperwork-derivations.const';

export const DERIVATIONS = {
  kinesiología: {
    section: 'Kinesiología',
    path: '/derivaciones/interconsultas',
  },
  fonoaudiología: {
    section: 'Fonoaudiología',
    path: '/derivaciones/interconsultas',
  },
  'terapia ocupacional': {
    section: 'Terapia Ocupacional',
    path: '/derivaciones/interconsultas',
  },
  [PAPERWORK_DERIVATIONS_DEFINITION.interconsultas.group]: {
    section: 'Interconsulta o Derivación',
  },
};

export const SPECIALTIES = {
  programa: 'Programa de Insuficiencia Cardiaca',
  programa_uc: 'Programa de Insuficiencia Cardiaca UC',
  unidad: 'Unidad Salud Mental Integral Psiquiatria o Psicologia',
  seguimiento: 'Seguimiento Orientacion Quirurgica',
  cefaleas: 'Programa Cefaleas UC',
  balance: 'Programa Espacio Balance Evaluacion Adulto TLM',
  balance2: 'Programa Espacio Balance Evaluacion Pediatrica TLM',
  balance3: 'Programa Espacio Balance',
  pemp: 'Psiquiatría de Enlace y Medicina Psicosomática Ambulatoria (PEMP Ambulatorio)',
}

export const MAIL_DERIVATIONS = {
  programa:    ['insuficienciacardiaca@ucchristus.cl'],
  programa_uc: ['insuficienciacardiaca@ucchristus.cl'],
  unidad:      ['contacto.providencia@ucchristus.cl'],
  seguimiento: ['teayudotelemedicina@ucchristus.cl'],
  cefaleas: ['cefaleas@ucchristus.cl'],
  balance: ['espaciobalance@ucchristus.cl'],
  pemp: ['pempambulatoriouc@gmail.com'],
}

export const HISTORY_PROFESSIONAL_ROUTE
  = `/${ROOT_ROUTES.clinical}/${CLINICAL_ROUTES.indications}/${DERIVATIONS_ROUTES.historyProfessionalInterconsultations}`;
